import { BaseModel, Form, Resource, Entry, EntryTypes } from '@ngx-resource-toolkit/core';
import { environment } from '../../../environments/environment';
import { LeaResource } from '../../shared/resource/lea.resource';
import { AbsenceModel } from '../../administration/absences/absences.model';
import { InscriptionModel } from '../../shared/inscriptions/inscription.model';
import { EleveReducer, EleveEpics } from './eleve.store';
import { Validators } from '@angular/forms';
import { civiliteFetchOptions } from '../../shared/resource/select-options';
import { FormGroup } from '@angular/forms';
import { TABLE } from '../../app.constantes';
import { ExamenResultatModel } from '../../shared/examen/models/examen-resultat.model';
import { DateHelper } from '../../shared/helpers/date.helper';
import { PhonePipe } from '../../shared/pipes/phone.pipe';
import { ValidationsHelper } from '../../shared/helpers/validations.helper';
import { statutEleveFetchOptions, niveauScolaireFetchOptions } from '../../shared/resource/select-options';
import * as moment from 'moment';

@Resource({
    modes: {
        'default': {
            url: environment.proxyUrl + '/eleve',
            methods: LeaResource.methods,
        }
    },
    store: {
        namespace: 'eleve',
        reducer: EleveReducer,
        epics: EleveEpics,
    }
})
@Form({
    'create': {
        onChanges: (value: EleveModel, form: any) => {
            const nom: string = form.value['nom'];
            if (nom) {
                form.patchValue({nom: nom.toUpperCase()},  {emitEvent: false});
            }
            const prenom: string = form.value['prenom'];
            if (prenom) {
                form.patchValue({prenom: prenom.charAt(0).toUpperCase() + prenom.substring(1)},  {emitEvent: false});
            }
        }
    },
    'edit': {},
    'table': {},
    'delete': {},
    'famille': {
        onChanges: (value: EleveModel, form: any) => {
            const nom: string = form.value['nom'];
            if (nom) {
                form.patchValue({nom: nom.toUpperCase()},  {emitEvent: false});
            }
            const prenom: string = form.value['prenom'];
            if (prenom) {
                form.patchValue({prenom: prenom.charAt(0).toUpperCase() + prenom.substring(1)},  {emitEvent: false});
            }
        }
    },
})
export class EleveModel extends BaseModel {

    @Entry({
        base: {
            hidden: true,
        },
        'create': {},
        'edit': {},
        'table': {},
        'delete': {},
        'famille': {},
    })
    _explicitType: string = 'Eleve';

    @Entry({
        'edit': {
            hidden: true,
        },
        'table': {
            label: 'N°',
            minWidth: TABLE.MIN_WIDTH.ID,
        },
        'delete': {
            hidden: true
        },
        'famille': {
            hidden: true,
        },
    })
    id: number;

    @Entry({
        base: {
            type: EntryTypes.TEXT,
            placeholder: 'Nom',
            label: 'Nom',
            css:  {
                group: 'col-xs-6',
                input: '',
            },
            validators: [Validators.required],
            validatorsMsgs: {
                'required': 'Le nom est obligatoire'
            },
        },
        'table': {
            minWidth: TABLE.MIN_WIDTH.NOM_PRENOM,
        },
        'create': {},
        'edit': {},
        'famille': {},
    })
    nom: string;

    @Entry({
        base: {
            type: EntryTypes.TEXT,
            placeholder: 'Prénom',
            label: 'Prénom',
            css:  {
                group: 'col-xs-6',
                input: '',
            },
        },
        'table': {
            minWidth: TABLE.MIN_WIDTH.NOM_PRENOM,
        },
        'create': {},
        'edit': {},
        'famille': {},
    })
    prenom: string;




    @Entry({
        base: {
            type: EntryTypes.SELECT,
            css: {
                group: 'col-xs-6',
            },
            label: 'Sexe',
            options: [{
                value: 'F',
                label: 'Féminin'
            }, {
                value: 'M',
                label: 'Masculin'
            }]
        },
        'create': {},
        'edit': {},
        'famille': {},
    })
    sexe: string;

    @Entry({
        base: {
            type: EntryTypes.SELECT,
            css: {
                group: 'col-xs-6',
            },
            label: 'Civilité',
            fetchOptions: civiliteFetchOptions,
        },
        'create': {},
        'edit': {},
        'famille': {},
    })
    civilite: string;
    civiliteLibelle: string;

    @Entry({
        base: {
            type: EntryTypes.STATIC,
            label: 'Famille',
            placeholder: 'Choix d\'une famille',
            css: {
                group: 'col-xs-6',
                btn: 'fa fa-search'
            },
            transform: (famille) => famille ? famille.nom : '',
            validators: [Validators.required],
            validatorsMsgs: {
                'required': 'La famille est obligatoire'
            },
        },
        'create': {},
        'edit': {},
    })
    famille: any; // Circular dependency

    @Entry({
        base: {
            type: EntryTypes.DATE,
            format: 'YYYY-MM-DD',
            placeholder: 'JJ/MM/AAAA',
            formatDisplay: 'DD/MM/YYYY',
            label: 'Date naissance',
            css: {
                group: 'col-xs-6',
            },
        },
        'create': {},
        'edit': {},
        'famille': {},
    })
    dateNaissStr: string;

    @Entry({
        base: {
            type: EntryTypes.TEXT,
            placeholder: 'Email',
            label: 'Email',
            css:  {
                group: 'col-xs-6',
                input: '',
            },
            validators: [ValidationsHelper.emailRegex()],
            validatorsMsgs: {
                'emailFormat': 'L\'email n\'est pas valide',
            }
        },
        'create': {

        },
        'edit': {},
        'famille': {},
        'table': {
            minWidth: TABLE.MIN_WIDTH.EMAIL,
        },
    })
    email: string;

    @Entry({
        base: {
            type: EntryTypes.TEXT,
            placeholder: 'Téléphone',
            label: 'Téléphone',
            css:  {
                group: 'col-xs-6',
                input: '',
            },
            validators: [ValidationsHelper.telephonePortableRegex()],
            validatorsMsgs: {
                'telephonePortableFormat': 'Le téléphone portable n\'est pas valide',
            }
        },
        'create': {},
        'edit': {},
        'famille': {},
        'table': {
            minWidth: TABLE.MIN_WIDTH.TEL,
            transform: (value) => value ? new PhonePipe().transform(value) : '',
        },
    })
	telephonePortable: string;

	dateCreation: string;

    @Entry({
        base: {
            type: EntryTypes.DATE,
            format: 'YYYY-MM-DD',
            placeholder: 'JJ/MM/AAAA',
            formatDisplay: 'DD/MM/YYYY',
            label: 'Date d\'entrée',
            css: {
                group: 'col-xs-6',
            },
        },
        'create': {
            default: moment(new Date()).format('YYYY-MM-DD'),
        },
        'edit': {},
        'famille': {},
    })
    dateEntree: string;

    @Entry({
        base: {
            type: EntryTypes.DATE,
            format: 'YYYY-MM-DD',
            placeholder: 'JJ/MM/AAAA',
            formatDisplay: 'DD/MM/YYYY',
            label: 'Date de sortie',
            css: {
                group: 'col-xs-6',
            },
        },
        'create': {},
        'edit': {},
        'famille': {},
        'table': {
            minWidth: TABLE.MIN_WIDTH.DATE,
            transform: (dateFin) => dateFin ? DateHelper.dateBDD2Date(dateFin).toLocaleDateString() : '',
        }
    })
	dateFin: string; // Date de fin = indique que l'élève a quitté l'école à cette date



    @Entry({
        base: {
            type: EntryTypes.SELECT,
            label: 'Statut',
            css: {
                group: 'col-xs-6',
            },
            // Ne pas mettre en dur mais récupérer ref_statut_eleve
            /*options: [{
                label: 'Enfant',
                value: '1'
            }, {
                label: 'Adulte',
                value: '2'
            }, {
                label: 'Etudiant',
                value: '4'
            }, {
                label: 'Autre',
                value: '3'
            }]*/
            fetchOptions: statutEleveFetchOptions
        },
        'create': {},
        'edit': {},
        'famille': {},
    })
    statut: number;

    @Entry({
        base: {
            type: EntryTypes.SELECT,
            label: 'Niveau scolaire',
            css: {
                group: 'col-xs-6',
            },
            fetchOptions: niveauScolaireFetchOptions
            // TODO récupérer ref_niveau_scolaire
            /*options: [{
                label: 'Primaire',
                value: '1'
            }, {
                label: 'Collège',
                value: '2'
            }, {
                label: 'Lycée',
                value: '3'
            }, {
                label: 'Etudiant',
                value: '4'
            }, {
                label: 'Adulte',
                value: '5'
            }]*/
        },
        'create': {},
        'edit': {},
        'famille': {},
    })
    niveauScolaire: number;

    @Entry({
        base: {
            type: EntryTypes.TEXT,
            label: 'Ecole',
            css:  {
                group: 'col-xs-6',
                input: '',
            },
        },
        'create': {},
        'edit': {},
        'famille': {},
    })
    ecole: string;

	statutLibelle: string;
    niveauScolaireLibelle: string;

    @Entry({
        base: {
            type: EntryTypes.DATE,
            format: 'YYYY-MM-DD',
            placeholder: 'JJ/MM/AAAA',
            formatDisplay: 'DD/MM/YYYY',
            label: 'Certificat médical',
            css: {
                group: 'col-xs-6',
            },
        },
        'create': {},
        'edit': {},
        'famille': {},
    })
    dateCertifMedical: string;

    @Entry({
        base: {
            type: EntryTypes.TEXTAREA,
            css: {
                group: 'col-lg-12 col-xs-12',
            },
            label: 'Saisie libre'
        },
        'create': {},
        'edit': {},
        'famille': {},
    })
    saisieLibre: string;

    @Entry({
        base: {
            type: EntryTypes.CHECKBOX,
            css:  {
                group: 'col-xs-6 col-lg-3',
                // input: 'checkbox-margin-top',
            },
            transform: (value) => value ? 'Oui' : 'Non',
            options: [{
                value: true,
                label: 'Hors cursus'
            }]
        },
        'create': {},
        'edit': {},
        'famille': {},
    })
    horsCursus: string;

    @Entry({
        base: {
            type: EntryTypes.CHECKBOX,
            options: [{
                value: true,
                label: 'Handicap',
            }],
            css:  {
                group: 'col-xs-6 col-lg-3',
                input: '',
            },
        },
        'create': {},
        'edit': {},
        'famille': {},
    })
    isHandicap: string;

    @Entry({
        base: {
            type: EntryTypes.CHECKBOX,
            options: [{
                value: true,
                label: 'Accord multimédia',
            }],
            css:  {
                group: 'col-xs-6 col-lg-3',
                input: '',
            },
        },
        'create': {},
        'edit': {},
        'famille': {},
    })
	accordMedia: string;

    @Entry({
        base: {
            type: EntryTypes.CHECKBOX,
            options: [{
                value: true,
                label: 'COM',
            }],
            css:  {
                group: 'col-xs-6 col-lg-3',
                input: '',
            },
            hidden: true,
        },
        'create': {},
        'edit': {},
        'famille': {},
    })
    bool_01: string;

    @Entry({
        base: {
            type: EntryTypes.CHECKBOX,
            options: [{
                value: true,
                label: 'Parc. pers.',
            }],
            css:  {
                group: 'col-xs-6 col-lg-3',
                input: '',
            },
            hidden: true,
        },
        'create': {},
        'edit': {},
        'famille': {},
    })
    bool_02: string;

	anneeScolaire: string;

	isRedoublant: string; // uniquement lorsque l'on fait une recherche par cours (car concerne l'inscription à ce cours)
    nbAnneeDansCycle: string; // uniquement lorsque l'on fait une recherche par cours (car concerne l'inscription à ce cours)

    absences: AbsenceModel[];
    inscriptions: InscriptionModel[];
    evaluations: ExamenResultatModel[]; //ExamenModel[];

    // Appelé lors d'un add depuis le modèle
    initAfterCreate(data?) {
        console.log('initAfterCreate', typeof data, data);
        if (data.parentForm && data.parentForm.value) {
            const parent = data.parentForm.value; // normalement Famille
            this.famille = parent;
            this.nom = parent.nom;
        }
    }
    constructor(data) {
        super();
        if (!data) {
            data = {};
        }
        Object.assign(this, data);
        this.statut = data.statut ? parseInt(data.statut) : null;
        this.niveauScolaire = data.niveauScolaire ? parseInt(data.niveauScolaire) : null;

        if (data.absences instanceof Array) {
            this.absences = [];
            data.absences.forEach((absence) => {
                this.absences.push(new AbsenceModel(absence));
            });
        }

        if (data.inscriptions instanceof Array) {
            this.inscriptions = [];
            data.inscriptions.forEach((inscription) => {
                this.inscriptions.push(new InscriptionModel(inscription));
            });
        }

        if (data.evaluations instanceof Array) {
            this.evaluations = [];
            data.evaluations.forEach((evaluation) => {
                this.evaluations.push(new ExamenResultatModel(evaluation));
                //this.evaluations.push(new ExamenModel(evaluation));
            });
        }
    }

}



// WEBPACK FOOTER //
// /builds/eveasoft/lea/lea-front/src/app/eleve/models/eleve.model.ts